import {AppSettings,SetAppSettingsAction} from '../types/types'
import { actionTypes } from '../types/enums';

const initialAppSettingsState:AppSettings = {       
        // dssUrl: "",
        apimSubKey: ""
  };

export const appSettings = (state:AppSettings = initialAppSettingsState, action:SetAppSettingsAction):AppSettings => {
          const { type, payload } = action;
              switch (type) {
                  case actionTypes.SET_APP_SETINGS:
                        return payload;
                  default:
                      return state;
              }
  };